import { render, staticRenderFns } from "./notification.vue?vue&type=template&id=45ba7894&scoped=true"
import script from "./notification.vue?vue&type=script&lang=js"
export * from "./notification.vue?vue&type=script&lang=js"
import style0 from "./notification.vue?vue&type=style&index=0&id=45ba7894&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45ba7894",
  null
  
)

export default component.exports